'use strict';

module.exports = '3.24.3';



//////////////////
// WEBPACK FOOTER
// ./node_modules/algoliasearch/src/version.js
// module id = 379
// module chunks = 0